import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      accountId,
      name,
      parent,
    }: {
      accountId: number
      name: string
      parent: string
    }) => {
      const { api, baseURL } = getApi()
      return api
        .post(
          `/api/v2/accounts/${accountId}/place-types`,
          { name, parent },
          { baseURL },
        )
        .then((res) => res.data.data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-place-types'] })
    },
  })
}
